import React from 'react';
import Highcharts, { isNumber } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import { moneyFormatter } from '../../helper';
import { useSelector } from 'react-redux';
import EmptyData from './EmptyData';

HighchartsMore(Highcharts);

const FindPriceTypePerYear = () => {
  const { chart } = useSelector((state) => state.checkPriceReducer);

  // chart type per year only shown if array contains value
  function chartByTypeShown(series) {
    const datas = series.map((data) => {
      const dataWithValue = data.data.map((item) => {
        return [item.high, item.low];
      });
      return dataWithValue.flat();
    });
    return datas.flat().some(isNumber);
  }

  const options = {
    chart: {
      type: 'columnrange',
      renderTo: 'chart2',
    },
    title: {
      text: chart.chart2 ? chart.chart2.title : '',
    },
    subtitle: {
      text: 'Harga terbentuk (Min Max) berdasarkan tipe per tahun',
    },
    xAxis: {
      title: { text: '<span class="d-none d-sm-block">Grade Kendaraan</span>' },
      categories: ['A', 'B', 'C', 'D', 'E'],
    },
    yAxis: {
      min: 0,
      title: {
        text: '<span class="d-none d-sm-block">Harga Kendaraan</span>',
      },
      labels: {
        formatter: function () {
          return moneyFormatter(this.value);
        },
      },
    },
    tooltip: {
      headerFormat: '<span style="font-size:12px; font-weight: bold">GRADE {point.key}</span><table>',
      pointFormat: `<tr style="font-size: 14px">
          <td style="padding:0">Harga Termurah {point.year}</td>
          <td style="padding:0px 5px;">:Rp. {point.low} </td>
      </tr>
      <tr style="font-size: 14px">
          <td style="padding:0">Harga Termahal {point.year}</td>
          <td style="padding:0px 5px;">:Rp. {point.high} </td>
      </tr>`,
      footerFormat: '</table>',
      shared: true,
      useHTML: true,
      // formatter: function () {
      //     const {high, low} = this.points[0].point;
      //     return (
      //         `<span style="font-size:12px; font-weight: bold">GRADE ${this.x}</span><table>` +
      //         `<tr style="font-size: 14px">
      //             <td style="padding:0">Harga Termahal</td>
      //             <td style="padding:0px 5px;">: ${moneyFormatter(high)}</td>
      //         </tr>
      //         <tr style="font-size: 14px">
      //             <td style="padding:0">Harga Termurah</td>
      //             <td style="padding:0px 5px;">: ${moneyFormatter(low)}</td>
      //         </tr></table>`
      //     )
      // }
    },
    responsive: [],
    credits: { enabled: false },
    legend: { enabled: false },
    series: chart.chart2 ? [...chart.chart2.series] : [],
  };

  return (
    <div id="chart2" className="col-xl-12">
      {!chartByTypeShown(options.series) && <EmptyData title={options.title.text} subTitle={options.subtitle.text} />}
      {chartByTypeShown(options.series) && <HighchartsReact highcharts={Highcharts} options={options} />}
    </div>
  );
};

export default FindPriceTypePerYear;
